import GamepageTemplate from "../components/containers/GamepageTemplate";

const NitroStreamIgnition = () =>{
    return(
        <GamepageTemplate 
            backgroundPng={"nitrostream3"}
            gameTitle={"NitroStream: Ignition"}
            gameDescription={"Fight a mob group in low profile street races alongside an anonymous sponsor"}
            embedYouTubeId={"roQtBOVj98k?si=qp_ANeeXDtnr1N9C"}
            downloadPath={"https://drive.google.com/uc?id=1nD_NL0DJA7R1n7VU2FHpMSiysuTaxE0Z"}
            gameVersion={"1.2.0"}
            versionDate={"2026-02"}
            allowBeta={false}
            allowLeaderboards={false}
            leaderboardsPath={"/ignition/leaderboards"}
        />  
    );
};

export default NitroStreamIgnition;